export const FormStatus = {
  PREPARATION: 'PREPARATION',
  AVAILABLE: 'AVAILABLE',
  ARCHIVED: 'ARCHIVED',
  toString(status) {
    switch (status) {
      case FormStatus.PREPARATION:
        return 'Em preparação'
      case FormStatus.AVAILABLE:
        return 'Disponível'
      case FormStatus.ARCHIVED:
        return 'Arquivado'
      default:
        return ''
    }
  }
}
